module.exports = __webpack_public_path__ + "static/media/wallet-line.9c3f4070.svg";